"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagGroupItem = void 0;
var react_1 = __importDefault(require("react"));
var TagGroupItem = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "TagGroup__Item" }, children));
};
exports.TagGroupItem = TagGroupItem;
//# sourceMappingURL=TagGroupItem.js.map